import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/home'

import Signup from '@/components/auth/signup'
import Login from '@/components/auth/login'
import Profile from '@/components/profile'
import EditAddress from '@/components/editaddress'
import Files from '@/components/Files';
//import OrderHistory from '@/components/orderhistory'
//import OrderHistory from '@/components/OrderHistory/OrderHistoryReckon'
import PreviousPurchaseProducts from '@/components/PreviousPurchaseProducts.vue';
import ViewOrder from '@/components/vieworder'
import ViewReckonOrder from '@/components/ViewOrder/ViewReckonOrder';


import ProductList from '@/components/productlist'
import AllProducts from '@/components/AllProducts'
import ProductDetail from '@/components/productdetail'
import Cart from '@/components/cart'
import Checkout from '@/components/checkout'
import ForgotPassword from '@/components/auth/forgot'
import Category from '@/components/category'
import CategoryProductList from '@/components/CategoryProductList'

import store from '../store.js';

Vue.use(Router)

const router =  new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: ForgotPassword
    },
    { 
      path: '/Products', 
      name: 'ProductList',
      component: ProductList,
      props: (route) => ({ criteria: route.query.q })
    },   
    { 
      path: '/Quick', 
      name: 'Quick',
      component: AllProducts
    },    
    { 
      path: '/ViewProduct', 
      name: 'ProductDetail',
      component: ProductDetail,
      props: (route) => ({ itemNumber: route.query.number })
    },
    { 
      path: '/cart', 
      name: 'Cart',
      component: Cart
    },
    { 
      path: '/checkout', 
      name: 'Checkout',
      component: Checkout
    },
    { 
      path: '/profile', 
      name: 'Profile',
      component: Profile
    },
    { 
      path: '/newaddress/', 
      name: 'NewAddress',
      component: EditAddress
    },
    { 
      path: '/editaddress/:key', 
      name: 'EditAddress',
      component: EditAddress
    },
    { 
      path: '/history', 
      name: 'OrderHistory',
      component: PreviousPurchaseProducts //OrderHistory
    },
    { 
      path: '/vieworder/:key', 
      name: 'ViewOrder',
      component: ViewOrder
    },
    { 
      path: '/vieworder/r/:key', 
      name: 'ViewReckonInvoice',
      component: ViewReckonOrder
    },
    { 
      path: '/category/:category', 
      name: 'Category',
      component: Category,
      props: (route) => ({ category: route.params.category })
    },
    { 
      path: '/category/:category/:subcategory', 
      name: 'CategorySubCategory',
      component: CategoryProductList,
      props: (route) => ({ category: route.params.category, subcategory: route.params.subcategory })
    },
    // {
    //   path: '/files',
    //   name: 'FileManager',
    //   component: Files
    // },
    
    { path: '*', redirect: '/' }
  ]
});

const allowedRoutes = [
  'signup',
  'login',
  'forgot'
];

router.beforeEach((to, from, next) => {

  if(!store.state.auth.userInfo && !process.env.ALLOW_ANONYMOUS && !allowedRoutes.includes(to.name)) {
    next({name: 'login'});
  }
  else {
    next();
  }
  
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js